//App
import { useQuery } from "@tanstack/react-query";
import { OrganizationContext } from "../OrganizationsContainer";
import { queryKeys } from "../constants";
import useForm from "../../hooks/useForm";

import {
    OrganizationContextData,
    OrganizationProps,
} from "../../../types/organization";
import organizationApi from "../../../app/model/api/organizationApi";

export const useOrganizationLookupsQuery = () =>
  useQuery({
    queryKey: [queryKeys.getOrganizationLookups],
    queryFn: () => organizationApi.getLookups(),
  });

export const useOrganization = (props: OrganizationProps) => {
    return useForm<OrganizationContextData, OrganizationProps>(
        OrganizationContext,
        props
    );
};
